import { useState } from 'react';
import {
  CheckoutModel,
  LmsModel,
  QuarterOverviewModel,
} from 'src/core/model/quarter-overview.model';
import { useEnhanceWithCheckout } from './use-enhance-with-checkout';
import { CheckoutSection } from './checkout-section';
import { CollapsibleQuarterOverviewTableRow } from '../quarter-overview-table/collapsible-quarter-overview.table-row';
import { useEnhanceWithChargingSession } from './use-enhance-with-charging-session';
import { ChargingSessionSection } from './charging-session-section';

type Props = {
  readonly quarterOverview: LmsModel;
  readonly rawCheckoutList?: CheckoutModel[];
  readonly onChange: (data: Partial<QuarterOverviewModel>) => void;
};

export function EnhanceQuarterOverview(props: Props): React.JSX.Element {
  const { rawCheckoutList, onChange, quarterOverview } = props;

  const [iTransactionId] = useState<string>();

  const { state: chargingSessionState, ...chargingSessionProps } =
    useEnhanceWithChargingSession({
      sessionId: quarterOverview.id,
      onChange,
    });

  const { state: checkoutState, ...checkoutProps } = useEnhanceWithCheckout({
    rawCheckoutList,
    iTransactionId,
    onChange,
  });

  return (
    <CollapsibleQuarterOverviewTableRow
      {...quarterOverview}
      chargingSessionState={chargingSessionState}
      checkoutState={checkoutState}>
      <ChargingSessionSection {...chargingSessionProps} />
      <CheckoutSection {...checkoutProps} />
    </CollapsibleQuarterOverviewTableRow>
  );
}
